import { FC, useState } from 'react';
import * as Collapsible from '@radix-ui/react-collapsible';
import classNames from 'classnames';

import { icon_chevron_down } from '@gn-audio/icons';
import { JabraIcon } from '@gn-audio/jss-components';

import { DownloadableResourceItem } from './DownloadableResourceItem';
import { DownloadableResourceGroupProps } from './downloadableResourceListTypes';

export const DownloadableResourceGroup: FC<DownloadableResourceGroupProps> = ({ group }) => {
  const { headline, items, disableAccordion, collapsedInitially } = group;

  const [isOpen, setIsOpen] = useState(!collapsedInitially?.value);

  if (!items?.length) return null;

  if (disableAccordion?.value || !headline?.value) {
    return (
      <div className="mb-10 last:mb-0">
        {headline?.value && <h2 className="heading-4 mb-4">{headline.value}</h2>}
        {group.description?.value && <p className="paragraph mb-6">{group.description.value}</p>}
        <div className="flex flex-col gap-4">
          {items?.map((item) => (
            <DownloadableResourceItem key={item.id} item={item} />
          ))}
        </div>
      </div>
    );
  }

  return (
    <Collapsible.Root className="mb-10 last:mb-0" open={isOpen} onOpenChange={setIsOpen}>
      <Collapsible.Trigger className="flex w-full items-center gap-2">
        {headline?.value && (
          <h2 className="heading-4 mb-4 flex items-center gap-2">
            {headline.value}
            <JabraIcon
              Icon={icon_chevron_down}
              className={classNames(
                'size-4 transition-transform duration-200',
                isOpen ? '-rotate-180' : '-rotate-0'
              )}
            />
          </h2>
        )}
      </Collapsible.Trigger>

      <Collapsible.Content>
        {group.description?.value && <p className="paragraph mb-6">{group.description.value}</p>}
        <div className="flex flex-col gap-4">
          {items?.map((item) => (
            <DownloadableResourceItem key={item.id} item={item} />
          ))}
        </div>
      </Collapsible.Content>
    </Collapsible.Root>
  );
};
